import { InquiryStatus } from './common';

export const InquiryStatusKr: Record<InquiryStatus, string> = {
  PENDING: '답변 대기',
  FOLLOW_UP: '답변 대기',
  ON_HOLD: '답변 대기',
  CLOSED: '문의 종료',
  ANSWERED: '답변 완료',
};
